import { useMutation } from 'react-query';
import { removeCache, saleService } from '../../../services';
import { SaleUpdateProps, IdProps } from '../../../types';

export const useDeleteManageSalesMutation = () => {
  return useMutation(
    (props: IdProps[]) => {
      return saleService.delete(props);
    },
    {
      onSettled: () => {
        removeCache(['container', 'gate-in', 'gate-out', 'sale', 'key']);
      },
    },
  );
};

export const useEditManageSalesMutation = () => {
  return useMutation(
    (props: SaleUpdateProps[]) => {
      return saleService.update(props);
    },
    {
      onSettled: () => {
        removeCache(['sale', 'key']);
      },
    },
  );
};
